import Popover from "@components/ui/popover";
import { cn } from "@lib/cn";
import {
  IconCheck,
  IconSelector,
  IconSortDescending,
} from "@tabler/icons-react";
import { useState } from "react";

const SORT_BY = [
  {
    label: "Recently read",
    value: "recently-read",
  },
  {
    label: "Name",
    value: "name",
  },
  {
    label: "Readers",
    value: "readers",
  },
  {
    label: "Reading time",
    value: "reading-time",
  },
  {
    label: "Engaged users",
    value: "engaged-users",
  },
  {
    label: "Avg. completed",
    value: "avg-completed",
  },
  {
    label: "Created date",
    value: "created-date",
  },
  {
    label: "Owner",
    value: "owner",
  },
];

const SORT_DIRECTION = [
  {
    label: "Ascending",
    value: "asc",
  },
  {
    label: "Descending",
    value: "desc",
  },
];

export const VersionsSort = ({
  sortBy,
  setSortBy,
  sortDirection,
  setSortDirection,
}: {
  sortBy: string;
  setSortBy: (value: string) => void;
  sortDirection: string;
  setSortDirection: (value: string) => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedSortLabel =
    SORT_BY.find((s) => s.value === sortBy)?.label || "Created date";

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen} placement="bottom-start">
      <Popover.Trigger
        className={cn(
          "tw-flex tw-h-9 tw-cursor-pointer tw-items-center tw-gap-1 tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-px-2 tw-transition-colors tw-duration-100 hover:tw-border-primary -md:tw-shrink-0",
          isOpen && "tw-border-primary",
        )}
      >
        <span className="tw-px-1 tw-font-sans tw-text-sm tw-font-medium tw-text-blue tw-flex tw-items-center">
          <IconSortDescending className="tw-size-4 tw-text-blue tw-mr-1.5" />
          <span className="-md:tw-hidden">Sort by: {selectedSortLabel}</span>
          <span className="tw-hidden -md:tw-block">Sort</span>
        </span>
        <IconSelector className="tw-size-4 tw-text-blue-500 -md:tw-hidden" />
      </Popover.Trigger>
      <Popover.Content className="tw-w-48 tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-shadow-md">
        {/* Sort by section */}
        <div className="tw-pt-1 tw-px-1">
          <div className="tw-flex tw-h-8 tw-items-center tw-px-2">
            <span className="tw-text-sm tw-text-blue-500">Sort by</span>
          </div>
        </div>
        <div className="tw-px-1 tw-pb-1">
          {SORT_BY.map((s) => (
            <button
              type="button"
              key={s.value}
              onClick={() => {
                setSortBy(s.value);
                setIsOpen(false);
              }}
              className={cn(
                "tw-flex tw-h-9 tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-rounded tw-px-4 tw-font-sans tw-text-sm tw-text-blue tw-outline-none tw-transition-colors hover:tw-bg-blue-50",
                {
                  "tw-bg-blue-100 hover:tw-bg-blue-100": sortBy === s.value,
                },
              )}
            >
              {s.label}
              {sortBy === s.value && (
                <IconCheck className="tw-size-4 tw-text-blue tw-ml-3" />
              )}
            </button>
          ))}
        </div>

        {/* Divider */}
        <div className="tw-h-px tw-bg-blue-100 tw-mx-1 tw-my-2" />

        {/* Sort direction section */}
        <div className="tw-pt-1 tw-px-1">
          <div className="tw-flex tw-h-8 tw-items-center tw-px-2">
            <span className="tw-text-sm tw-text-blue-500">Sort direction</span>
          </div>
        </div>
        <div className="tw-px-1 tw-pb-1">
          {SORT_DIRECTION.map((s) => (
            <button
              type="button"
              key={s.value}
              onClick={() => {
                setSortDirection(s.value);
                setIsOpen(false);
              }}
              className={cn(
                "tw-flex tw-h-9 tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-rounded tw-px-4 tw-font-sans tw-text-sm tw-text-blue tw-outline-none tw-transition-colors hover:tw-bg-blue-50",
                {
                  "tw-bg-blue-100 hover:tw-bg-blue-100":
                    sortDirection === s.value,
                },
              )}
            >
              {s.label}
              {sortDirection === s.value && (
                <IconCheck className="tw-size-4 tw-text-blue tw-ml-3" />
              )}
            </button>
          ))}
        </div>
      </Popover.Content>
    </Popover>
  );
};
